import { render, staticRenderFns } from "./admin_operation.vue?vue&type=template&id=2601cab4&scoped=true&"
import script from "./admin_operation.vue?vue&type=script&lang=js&"
export * from "./admin_operation.vue?vue&type=script&lang=js&"
import style0 from "./admin_operation.vue?vue&type=style&index=0&id=2601cab4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601cab4",
  null
  
)

export default component.exports